// DS: i4.62
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Reorder: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5 17C8.60457 17 9.5 17.8954 9.5 19C9.5 20.1046 8.60457 21 7.5 21C6.39543 21 5.5 20.1046 5.5 19C5.5 17.8954 6.39543 17 7.5 17ZM16.5 17C17.6046 17 18.5 17.8954 18.5 19C18.5 20.1046 17.6046 21 16.5 21C15.3954 21 14.5 20.1046 14.5 19C14.5 17.8954 15.3954 17 16.5 17ZM7.5 10C8.60457 10 9.5 10.8954 9.5 12C9.5 13.1046 8.60457 14 7.5 14C6.39543 14 5.5 13.1046 5.5 12C5.5 10.8954 6.39543 10 7.5 10ZM16.5 10C17.6046 10 18.5 10.8954 18.5 12C18.5 13.1046 17.6046 14 16.5 14C15.3954 14 14.5 13.1046 14.5 12C14.5 10.8954 15.3954 10 16.5 10ZM7.5 3C8.60457 3 9.5 3.89543 9.5 5C9.5 6.10457 8.60457 7 7.5 7C6.39543 7 5.5 6.10457 5.5 5C5.5 3.89543 6.39543 3 7.5 3ZM16.5 3C17.6046 3 18.5 3.89543 18.5 5C18.5 6.10457 17.6046 7 16.5 7C15.3954 7 14.5 6.10457 14.5 5C14.5 3.89543 15.3954 3 16.5 3Z"
        fill="currentColor"
      />
    </svg>
  </IconWrap>
);

export default Reorder;
